export default __webpack_public_path__ + "static/media/DXPanel-Hindi-Logo-without-BG.12939190.png";